export enum SiteSectionSlug {
	MCO = 'mco',
	ORL = 'orlando-executive-airport',
	BUSINESS = 'airport-business',
	MCOCARES = 'mcocares',
}
